// import pages
import * as Sentry from "@sentry/browser";
import { createRoot } from "react-dom/client";

import { setupAxiosInterceptors } from "./api/axiosConfig";
import App from "./App";

import "../sass/style.scss";

// Axios インターセプターの初期化（セッション切れ検知を設定）
setupAxiosInterceptors();

// 本番環境ではconsole.logを無効化
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

Sentry.init({
  dsn: window.SENTRY_DSN,
  release: window.COMMIT_SHA,
});

const root = createRoot(document.getElementById("react-app") as HTMLElement);
root.render(<App />);
